<template>
	<div class="page">
		<!-- your page -->
		<Head></Head>
		<div class="fixation">
			<div class="leftNav">
				<div class="info">
					<div class="avatar">
						<div class="avatarIn">
							<img :src="userinfo.avatar" alt="">
						</div>
					</div>
					<div class="username">
						{{userinfo.nickname}}
					</div>
					<div class="score">
						<i class="el-icon-medal"></i>当前积分:{{userinfo.score}}
					</div>
				</div>
				<div class="menu">
					<div class="block" v-for="(item,index) in menu" :key="index">
						<div class="blockTitle">
							<div class="icon">
								<i :class="item.class"></i>
							</div>
							<div class="title">
								{{item.name}}
							</div>
						</div>
						<div class="line" v-for="(tab,tabIndex) in item['tab']" :key="tabIndex" :data-id="tab.id" :id="tab.select">
							<router-link :to="{path:'/person/'+tab.router,query:{mid:tab.id}}" @click.native="tabRouter" :data-id="tab.id">
								{{tab.name}}
								<i class="el-icon-arrow-right"></i>
							</router-link>
						</div>
					</div>
				</div>
			</div>
			<div class="rightBox">
				<router-view ref='order'></router-view>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	// your script
	import Head from '../../components/head.vue'
	import Foot from '../../components/foot.vue'
	export default {
		name: 'person',
		components:{
			Head,Foot
		},
		provide(){
			return{
				getParentInfo:this.getUserInfo,
				tabRouter:this.tabRouter
			}
		},
		data(){
			return {
				menu:[
					{class:"el-icon-shopping-bag-1",name:"我的购物",tab:[{router:"order",id:"0",select:"select",name:"全部订单"},{router:"order",id:"1",select:"",name:"待付款"},{router:"order",id:"2",select:"",name:"待发货"},{router:"order",id:"3",select:"",name:"待收货"},{router:"order",id:"4",select:"",name:"待评价"},{router:"order",id:"6",select:"",name:"售后"}]},
					{class:"el-icon-setting",name:"设置中心",tab:[{router:"info",id:"8",select:"",name:"个人资料"},{router:"address",id:"9",select:"",name:"收货地址"},{router:"changePass",id:"10",select:"",name:"修改密码"},{router:"about",id:"11",select:"",name:"关于我们"}]},
					{class:"el-icon-share",name:"积分中心",tab:[{router:"record",id:"7",select:"",name:"积分记录"}]}
				],
				userinfo:{
					"avatar":"",
					"id":"",
					"mobile":"",
					"nickname":"",
					"username":""
				},
				childId:100
			}
		},
		methods:{
			tabRouter(e){
				var id = e.target.dataset.id
				this.setDefaultMenu(id)
				this.setChildMenu(id)
			},
			getUserInfo(){
				var userinfo = localStorage.getItem('userInfo')
				this.userinfo = JSON.parse(userinfo)
			},
			setDefaultMenu(id){
				var menu = this.menu
				for (var i = 0; i < menu.length; i++) {
					for (var k = 0; k < menu[i].tab.length; k++) {
						var tid = menu[i].tab[k].id
						menu[i].tab[k].select=""
						if(id==tid){
							menu[i].tab[k].select="select"
						}
					}
				}
				this.menu = menu
			},
			setChildMenu(id){
				id = parseInt(id)
				if(id>=0&&id<=6){
					this.$refs.order.navChange(id)
				}
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
			this.token = localStorage.getItem('token')
			if(this.token!=null){
				this.getUserInfo()
			}
			var mid = this.$route.query.mid
			this.setDefaultMenu(mid)
			this.setChildMenu(mid)
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	}
</script>

<style scoped>
	/* your css */
	.fixation{
		font-size: 0px;
		letter-spacing: -6px;
	}
	.leftNav,.rightBox{
		height: 100%;
		display: inline-block;
		vertical-align: top;
		letter-spacing: normal;
		background: #FFFFFF;
		margin-top: 10px;
		box-shadow: 3px 3px 3px #E3E3E3;
	}
	.leftNav{
		width: 240px;
	}
	.rightBox{
		width: 940px;
		min-height: 790px;
		margin-left: 20px;
	}
	.info{
		width: 100%;
		height: 200px;
		background: #4C95EF;
	}
	.avatar{
		width: 100%;
		height: 120px;
		padding-top: 20px;
		box-sizing: border-box;
	}
	.avatarIn{
		width: 100px;
		height: 100%;
		border-radius: 50%;
		border: 2px solid #FFFFFF;
		box-sizing: border-box;
		margin: 0 auto;
		overflow: hidden;
	}
	.avatarIn img{
		width: 100%;
		height: 100%;
	}
	.username{
		margin-top: 10px;
	}
	.username,.score{
		width: 100%;
		height: 30px;
		text-align: center;
		line-height: 30px;
		color: #FFFFFF;
		letter-spacing: 1px;
	}
	.menu{
		width: 100%;
	}
	.block{
		width: 100%;
	}
	.blockTitle{
		width: 100%;
		height: 50px;
		line-height: 50px;
		background: #F0F0F0;
		color:#197aff;
	}
	.icon{
		width: 40px;
		height: 100%;
		float: left;
	}
	.icon i{
		font-size: 20px;
		color: #036DEE;
		margin: 15px auto;
		display: block;
		width: 20px;
		height: 20px;
	}
	.title{
		width: 160px;
		height: 100%;
		float: left;
	}
	.line{
		width: 100%;
		height: 40px;
		line-height: 40px;
		padding: 0px 10px;
		box-sizing: border-box;
		cursor: pointer;
	}
	.line:hover{
		background: #F0F0F0;
	}
	.line a{
		color: #333333;
		display: block;
		width: 100%;
		height: 100%;
	}
	.line i{
		float: right;
		display: block;
		margin: 13px auto;
	}
	#select{
		border-left: 2px solid #036DEE;
		box-sizing: border-box;
		background: #F0F0F0;
	}
</style>
